import React from 'react'
import './PricesPage.css'
import Header from '../components/Header'

function PricesPage() {

  return (
    <div className="page_container" id="prices-page">
      <section className="page_section" id="hero-section">
        <Header />
        <div className="sub_section title_section">
          <h1>Prijzen</h1>
        </div>
        <div className="sub_section no_padding iframe_section">
          <iframe src="https://poledistrict85.trainin.app/widget/shop" style={{width: '100%', height: '650px', border: 'none'}}></iframe>
        </div>
      </section>
    </div>
  )
}

export default PricesPage 